import EditIcon from '@mui/icons-material/Edit'
import { IconButton, useTheme } from '@mui/material'

const EditIconButton = ({ onEdit }) => {
  const theme = useTheme()
  return (
    <IconButton
      onClick={onEdit}
      sx={{
        width: '50px', // Same size as PandaIconBorder
        height: '50px',
        borderRadius: '50%',
        border: `1px solid ${theme.palette.background.button}`,
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
        '&:hover': {
          backgroundColor: 'background.button',
        },
      }}
    >
      <EditIcon sx={{ fontSize: '28px' }} /> {/* Adjusted size for consistency */}
    </IconButton>
  )
}

export default EditIconButton
